<!--
  - This file is part of the Web3 Library developed by mFactory GmbH.
  -
  - Copyright © 2021, mFactory GmbH
  -
  - Solana Reference Stake Pool is free software: you can redistribute it
  - and/or modify it under the terms of the GNU Affero General Public License
  - as published by the Free Software Foundation, either version 3
  - of the License, or (at your option) any later version.
  -
  - Solana Reference Stake Pool is distributed in the hope that it
  - will be useful, but WITHOUT ANY WARRANTY; without even the implied
  - warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
  - See the GNU Affero General Public License for more details.
  -
  - You should have received a copy of the GNU Affero General Public License
  - along with this program.
  - If not, see <https://www.gnu.org/licenses/agpl-3.0.html>.
  -
  - You can be released from the requirements of the Affero GNU General Public License
  - by purchasing a commercial license. The purchase of such a license is
  - mandatory as soon as you develop commercial activities using the
  - Solana Reference Stake Pool code without disclosing the source code of
  - your own applications.
  -
  - The developer of this program can be contacted at <info@mfactory.ch>.
  -->

<script lang="ts" setup>
import { computed, ref, watch } from 'vue'
import { useClusterStore } from '~/store'

const {
  tpsThreshold = 1500,
} = defineProps<{
  tpsThreshold?: number
}>()

const clusterStore = useClusterStore()
const tpsLoading = computed(() => clusterStore.tpsLoading)
const tps = computed(() => clusterStore.tps)
const style = ref()
const message = ref()

const handleTps = () => {
  let msg, backgroundColor
  console.log('[TPS]:', tps.value)

  if (!tpsLoading.value) {
    if (tps.value <= 0) {
      msg = 'Solana cluster failure. Try refreshing the page; if the problem persists, please contact us via Discord.'
      backgroundColor = 'var(--q-negative)'
    } else if (tps.value < tpsThreshold) {
      msg = 'Solana network is experiencing degraded performance. Transactions may fail to send or confirm.'
      backgroundColor = 'var(--q-info)'
    } else {
      msg = undefined
    }
  }

  message.value = msg
  style.value = {
    backgroundColor: backgroundColor ?? 'none',
    height: msg ? 'auto' : 0,
    padding: msg ? '5px' : 0,
  }
}

watch(tps, async () => {
  setTimeout(handleTps, 500)
}, { immediate: true })
</script>

<template>
  <q-slide-transition>
    <div v-if="message" :class="$style.root" :style="style">
      {{ message }}
    </div>
  </q-slide-transition>
</template>

<style module lang="scss">
.root {
  position: relative;
  width: 100%;
  margin-top: -24px;
  padding: 5px;
  background: rgba($info, 0.94);
  color: #fff;
  font-weight: 500;
  font-size: 0.9rem;
  z-index: 10000;
  text-align: center;

  @media (max-width: $breakpoint-xs) {
    margin-top: -18px;
  }
}
</style>
